import Background from 'ui/Background';
import ClickableMixin from './mixins/ClickableMixin';
import ContainableMixin from './mixins/ContainableMixin';
import mixin from 'privates/utils/mixin';

/**
 * @class Container
 * @summary A container for Repeater items.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname cell
 * @viewername wysiwyg.viewer.components.MediaContainer
 */

class Container extends Background {

    constructor(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        super(RMI, compId, contextId, wixSelector, controllerId, role, type);
        mixin(Container.prototype, ClickableMixin.prototype);
        mixin(Container.prototype, ContainableMixin.prototype);
    }

    toJSON() {
        const {id, type, global, rendered, title} = this;
        return {id, type, global, rendered, title};
    }
}

export default Container;



// WEBPACK FOOTER //
// ./js/modules/ui/Container.es6